import { of, EMPTY } from 'rxjs';
import { take } from 'rxjs/operators';
import { ofType } from 'redux-observable';

import { BULK_PURCHASE_END } from './bulk.purchase.actions';
import { startBulkPrint } from '../print/bulk.print.actions';
import { trackBulkLabelPrintingStart } from '../../../store/labels/tracking-events';

export const waitForEndOfBulkPurchase = ({ action$ }) => {
  return action$.pipe(ofType(BULK_PURCHASE_END), take(1));
};

export const handleBulkPurchaseEnd = ({
  includedFulfillmentPlanIds = [],
  excludedFulfillmentPlanIds = [],
  erroredFulfillmentPlanIds = [],
  andPrint = false,
  labelBatchId,
}) => {
  const included = includedFulfillmentPlanIds.map((id) => id.toString());
  const excluded = excludedFulfillmentPlanIds.map((id) => id.toString());
  const errored = erroredFulfillmentPlanIds.map((id) => id.toString());

  const fpIdsWithLabelsCreated = included.filter((id) => !errored.includes(id) && !excluded.includes(id));
  const allPrintableFpIds = [...fpIdsWithLabelsCreated, ...excluded];

  if (andPrint && allPrintableFpIds.length) {
    trackBulkLabelPrintingStart(allPrintableFpIds, labelBatchId);
    return of(startBulkPrint(allPrintableFpIds, labelBatchId));
  }

  return EMPTY;
};
